// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eec8f334","488":"68521f19","977":"d0d2d84d"}[chunkId] + ".chunk.js";
};